import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
  ],
  providers: [
  ],
})
export class CoreUtilModule {}
